<!--
  Used as a container for <input-header>, headers of a <button-group>
-->

<template>
  <div class="input-headers-group">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'InputHeadersGroup',
}
</script>

<style lang="scss">
@import "../../element-variables.scss";

.input-headers-group {
  display: flex;
  // some margin to stop the lower border near the rounded edges of the <button-group>
  margin: $input-header-vpadding $input-header-hmargin 0;
  // a lower border to mimic the border of a <button-group>
  border-bottom: 1px solid $--border-color-base;
}
</style>
